import React from 'react';
import { Pill } from './Pill';
import { bonuses } from '../data/bonuses';
export function BonusesSection() {
  return <section className="w-full bg-blush py-10 sm:py-12" aria-labelledby="bonuses-heading" data-id="element-13" data-mp="gwos9ahfs02j">
      <div className="mx-auto max-w-6xl px-6" data-id="element-14" data-mp="vt60vty8r0le">
        <div className="mx-auto max-w-2xl text-center" data-id="element-15" data-mp="vqtcoz1w3tzw">
          <Pill tone="rose" data-id="element-16" data-mp="qsrsubwn3qnd">Included at no extra cost</Pill>
          <h2 id="bonuses-heading" className="mt-5 font-display text-4xl leading-tight text-charcoal sm:text-5xl" data-id="element-17" data-mp="14tkqh5i8n1up">
            7 Strategic Bonuses
            <span className="mt-1 block italic text-wine" data-id="element-18" data-mp="ztq1j7i0wmca">Always Included</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl font-sans text-sm leading-relaxed text-ash" data-id="element-19" data-mp="1ei2ml9fkoks0">
            The Elite Bonus Vault —{' '}
            <span className="font-semibold text-wine" data-id="element-20" data-mp="19mdufr5vu65q">value $200+</span>, all
            included in your $27 investment.
          </p>
        </div>

        <ul className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-21" data-mp="1jj9wbe19zu1b">
          {bonuses.map(bonus => <li key={bonus.number} className="flex h-full flex-col rounded-3xl border border-rose-deep/20 bg-cream p-5 shadow-soft" data-id="element-22" data-mp="3pr3msgyk4kor">
              <div className="relative overflow-hidden rounded-2xl bg-parchment" data-id="element-23" data-mp="3tsfdyqx2xdz2">
                <img src={bonus.image} alt={bonus.alt} className="mx-auto h-52 w-full object-contain py-4" width={620} height={620} loading="lazy" data-id="element-24" data-mp="2kkvh0uofw4d" />
                <span className="absolute left-3 top-3 rounded-full bg-wine px-3 py-1 font-sans text-[10px] font-semibold uppercase tracking-[0.14em] text-cream" data-id="element-25" data-mp="7icm7rjl5c6z">
                  Bonus {bonus.number}
                </span>
                <span className="absolute right-3 top-3 rounded-full bg-charcoal px-3 py-1 font-sans text-[10px] font-semibold uppercase tracking-[0.14em] text-rose" data-id="element-26" data-mp="lblqjdsof7in">
                  Free
                </span>
              </div>

              <h3 className="mt-5 font-display text-2xl leading-snug text-charcoal" data-id="element-27" data-mp="vbl0nf4qv5xm">
                {bonus.title}
              </h3>
              <p className="mt-auto pt-2 font-sans text-sm leading-relaxed text-ash" data-id="element-28" data-mp="10707vo88y3l2">
                {bonus.description}
              </p>
            </li>)}
        </ul>

        <p className="mx-auto mt-9 max-w-2xl rounded-full border border-gold/40 bg-cream px-8 py-4 text-center font-display text-xl text-wine" data-id="element-29" data-mp="5npbi6bkbyq2">
          Total bonus value: $200+ — yours free today.
        </p>
      </div>
    </section>;
}